import './editableTag.scss';
import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import classNames from 'clsx';
import {HibuSelect} from '../select/hibuSelect';
import {Option} from '../select/select';
import {useTagDropdownOptions} from '../../config/config-hooks';
import {renderActionButtons} from '../../search/search-results/search-result-details/details/details.utils';
import {useWithConfirmation} from '../hibuModal/hibuModal';

type InputProps = {
    value?: Option;
    onSubmit: (newValue: Option) => void;
    onUserValidation: () => void;
    onDelete: () => void;
    allowEditing?: boolean;
    tagGroupName: string;
    userValidationEnabled?: boolean;
    userValidated?: boolean;
};

export const EditableTagWithOptions = React.memo((props: InputProps) => {
    const {t} = useTranslation();
    const tagDropdownOptions = useTagDropdownOptions();

    const [editModeActive, setEditModeActive] = useState<boolean>(false);

    function getTagOptions(tagGroupName: string): Option[] {
        return tagDropdownOptions && tagDropdownOptions[tagGroupName] ? tagDropdownOptions[tagGroupName] : [];
    }

    const {onClick: buildDeleteClick} = useWithConfirmation(
        t('fieldTitle.tags.modal.deleteTag.message', {
            group: t('fieldTitle.tagsPlural.' + props.tagGroupName + '.label'),
            tag: props.value?.label
        }),
        {
            backdrop: true,
            keyboard: true,
            closeButton: false,
            title: t('fieldTitle.tags.modal.deleteTag.title'),
            cancel: t('general.cancel'),
            ok: t('general.clear'),
        }
    );

    return (
        <div
            className={classNames('submittable-input', editModeActive ? 'edit-active' : '', props.allowEditing ? 'action-enabled' : '')}>
            <HibuSelect
                name="tag-value-select"
                className={classNames('tag-value-select', 'searchable')}
                value={props.value || undefined}
                options={getTagOptions(props.tagGroupName)}
                onChange={props.onSubmit}
                isSearchable
                placeholder={t('general.select', {entry: props.tagGroupName})}
                onOpenMenu={() => setEditModeActive(true)}
                onCloseMenu={() => setEditModeActive(false)}
            />
            {renderActionButtons(
                props.onUserValidation,
                props.onDelete,
                t,
                props.userValidated,
                props.userValidationEnabled,
                buildDeleteClick(() => props.onDelete())
            )}
        </div>
    );
});
